// lodash/fp compose doesn't infer types regularly because of unknown (sperad)
// array length at runtime.
// ref: https://github.com/Microsoft/TypeScript/issues/4130
export function compose<In>(...functions: Array<(arg: In) => In>) {
  return functions.reduce(
    (accFn, nextFn) => value => accFn(nextFn(value)),
    value => value
  );
}
